import * as React from 'react';

import Login from 'views/login/Login';
import {removeSplashPage} from 'helpers/removeSplashPage';

export default (): JSX.Element => {
  removeSplashPage();
  return <Login />;
};
